import React, { Component, lazy, Suspense, useEffect } from 'react';
import { Route, Switch, Link, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { isAuthenticated } from '../../services/auth';

import logo from '../../assets/images/logo-code7-boteria.svg';
import Footer from '../../components/Footer2';
import Loading from '../../components/Loading';

import './Auth.scss';
import CreatePassword from '../createPassword';

const Login = lazy(() => import('../../components/Auth/Login'));
const SignUp = lazy(() => import('../../components/Auth/SignUp'));
const ResetPassword = lazy(() => import('../../components/Auth/ResetPassword'));
const RecoverPassword = lazy(() =>
  import('../../components/Auth/RecoverPassword')
);
const ContaCriada = lazy(() => import('../../components/Auth/ContaCriada'));
const RecoverEmail = lazy(() => import('../../components/Auth/RecoverEmail'));
const Confirm = lazy(() => import('../../components/Auth/Confirm'));

const Auth = (props) => {
  const location = useLocation();
  const { match } = props;

  useEffect(() => {
    if (isAuthenticated()) {
      const { history } = props;
      if (location.search !== '') {
        const parsed = queryString.parse(location.search);
        if (parsed) {
          history.push(`/home?${queryString.stringify(parsed)}`);
        }
      } else {
        history.push('/home');
      }
    }
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <section className="d-flex justify-content-center logo">
            <Link to="/">
              <img alt="Logo" src={logo} />
            </Link>
          </section>
        </div>
      </div>

      <section className="d-flex justify-content-center">
        <Suspense fallback={<Loading loading={false} />}>
          <Switch>
            <Route path={`${match.url}signup`} exact component={SignUp} />
            <Route
              path={`${match.url}signup/:registerMethod`}
              exact
              component={SignUp}
            />
            <Route
              path={`${match.url}reset-password/:email/:token`}
              component={ResetPassword}
            />
            <Route path="/password/create/:token" component={CreatePassword} />

            <Route
              path={`${match.url}account-created`}
              component={ContaCriada}
            />
            <Route
              path={`${match.url}recover-password`}
              component={RecoverPassword}
            />
            <Route
              path={`${match.url}recover-email`}
              component={RecoverEmail}
            />
            <Route path={`${match.url}login`} component={Login} />
            <Route path={`${match.url}confirm`} component={Confirm} />
            <Route path={`${match.url}`} component={Login} />
          </Switch>
        </Suspense>
      </section>

      <Footer />
    </div>
  );
};

export default Auth;
